import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fb6454e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "I want to invest", -1))
const _hoisted_2 = { class: "stake-amount-input__wrapper" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "stake-amount-input__fiat"
}
const _hoisted_5 = {
  key: 1,
  class: "stake-amount-input__fiat"
}

import { PropType, computed, ref, ComponentPublicInstance } from "vue";
import { Token } from "@/types/token";


export default /*#__PURE__*/_defineComponent({
  __name: 'stake-amount-input',
  props: {
  token: {
    type: Object as PropType<Token>,
    default: null,
  },
  isError: {
    type: Boolean,
    default: false,
  },
  value: {
    type: String,
    default: () => {
      return "";
    },
  },
},
  emits: ["update:amount"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const inputRef = ref<ComponentPublicInstance<HTMLInputElement>>();
__expose({ inputRef });





const amountUsd = computed(() => {
  return props.token.price.times(props.value).toNumber();
});

const textValue = computed({
  get: () => (props.value != "0" ? props.value.replace(/[^0-9.-]+/g, "") : ""),
  set: (value) => emit("update:amount", value.replace(/[^0-9.-]+/g, "")),
});

const size = computed(() => {
  return textValue.value.length == 0 ? 70 : textValue.value.length;
});

const focus = () => {
  if (inputRef.value) inputRef.value.focus();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["stake-amount-input", { error: __props.isError }])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        ref_key: "inputRef",
        ref: inputRef,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textValue).value = $event)),
        type: "text",
        class: "stake-amount-input__input",
        placeholder: `0 ${__props.token.symbol.toLocaleUpperCase()}`,
        style: _normalizeStyle({ width: size.value + 'ch' })
      }, null, 12, _hoisted_3), [
        [_vModelText, textValue.value]
      ]),
      _withDirectives(_createElementVNode("span", { onClick: focus }, _toDisplayString(__props.token.symbol), 513), [
        [_vShow, props.value != '0']
      ])
    ]),
    (props.value == '0')
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$filters.currencyFormat(0, "USD")), 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_5, " ~" + _toDisplayString(_ctx.$filters.currencyFormat(amountUsd.value, "USD")), 1))
  ], 2))
}
}

})